(function () {

    SUGApp.config(['$routeProvider', '$compileProvider', function ($routeProvider, $compileProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(http|https|mailto|data):/);
        $routeProvider
            .when('/', {
                  templateUrl: '/view/members/integrations/manage-integrations.html'
                //DO NOT include controller or controllerAs here to prevent duplicate controller load, AND properly expose named scope in $parent
            })
            .when('/integration/:key/:mid?', {
                  templateUrl: '/view/members/integrations/npe-manage.html'
                , controller: 'manageNonProfitEasyController'
                , resolve: {
                    // confirm access to this page
                    routeparams:['$route', function($route){ return $route.current.params; }]
                }
            })
            .otherwise({
                redirectTo: '/'
            });
    }]);

}());

(function () {
    /* Controller */
    SUGApp.controller('manageIntegrationsController', manageIntegrationsController);
    manageIntegrationsController.$inject = ['$scope','$filter','$location','$modal','$q','$timeout','$window','sugCacheFactory','SUGUtilities','errorService','globalService','integrationService'];
    function manageIntegrationsController(   $scope, $filter, $location, $modal, $q, $timeout, $window, sugCacheFactory, SUGUtilities, errorService, globalService, integrationService ) {

        /**
         * Setup ControllerAs named scope.
         * We only need it for the statusmsg var,
         * so everything else can stay on $scope for simplicity
         */
        var sug_integrations = this;

        /* init vars */
        $scope.isProcessing = false;
        $scope.loaded=false;
        $scope.fullsecureurl = ( typeof window.globalcfg.secureURL != 'undefined' ) ? window.globalcfg.secureURL : 'https://www.signupgenius.com';
        var reg = /^https?:\/\//;
        $scope.secureurl = $scope.fullsecureurl.replace(reg,'');
        $scope.userdef = {};

        var _loginwindow = null;
        var _hasNpeTokens = null;
        var _npeLoginUrl = '';
        var _appFeatureName = 'NonProfitEasy-AppFeature';

        // integration data properties
        //TODO : load from new integration table
        $scope.integrations = [
            {
                name:             'NonProfitEasy'
              , classname:        'npe'
              , modalimage:       '/images/integrations/settings-npe.png'
              , ispro:            true
              , productlabel:     'enterprise'
              , productrank:      5
              , logoimage:        '/images/integrations/settings-npe.png'
              , imagealt:         'Non-Profit Easy integration'
              , briefdesc:        'Connect your sign ups with NonProfitEasy CRM.'
              , fulldesc:         'NonProfitEasy is a CRM system that empowers nonprofits to easily and efficiently manage relationships. With a feature-rich platform and a user-friendly interface, NonProfitEasy will help you reach more donors, raise more funds, sell more memberships, and track more interactions and tasks than you ever thought possible.'
              , learnmoremodal:   true
              , learnmorebtn:     'Read About Our Integration'
              , learnmorelink:    '/blog/now-integrated-with-nonprofiteasy-crm.cfm'
              , managebtn:        true
              , managebtnlabel:   'Sign in with NonProfitEasy'
              , managebtnshowicon: false
              , order:            1
              , controlled:       true
              , enabled:          true
          },
          {
              name:               window.globalcfg.solutions.donations.fullname
            , classname:          'sug-' + window.globalcfg.solutions.donations.shortname.toLowerCase()
            , modalimage:         '/images/integrations/settings-donations.png'
            , ispro:              false
            , productlabel:       ''
            , productrank:        0
            , logoimage:          '/images/integrations/sug-donations-250.png'
            , imagealt:           window.globalcfg.solutions.donations.fullname + ' integration'
            , briefdesc:          'Connect a ' + window.globalcfg.solutions.donations.fullname + ' Campaign with your sign ups.'
            , fulldesc:           window.globalcfg.solutions.donations.fullname + ' gives individuals and groups the power to fundraise quickly, without minimum raise fees. Organizers create a unique web page to share their story and collect donations, and they can then share their campaign with donors.'
            , learnmoremodal:     true
            , learnmorebtn:       'Read About Our Integration'
            , learnmorelink:      '/blog/signupgenius-donations'
            , managebtn:          false
            , managebtnlabel:     ''
            , managebtnshowicon: false
            , order:              2
            , controlled:         false
            , enabled:            true
          },
          {
                name:             'Zoom'
              , classname:        'zoom'
              , modalimage:       '/images/integrations/settings-zoom.png'
              , ispro:            false
              , productlabel:     ''
              , productrank:      0
              , logoimage:        '/images/integrations/settings-zoom.png'
              , imagealt:         'Zoom integration'
              , briefdesc:        'Add Zoom links directly to the location field of your sign ups.'
              , fulldesc:         'Zoom is a software built for enterprise video communications, with an easy, reliable cloud platform for video and audio conferencing, collaboration, chat, and webinars across mobile devices, desktops, telephones and room systems. Use Zoom to meet for conferences, training sessions, team meetings, classes and more.'
              , learnmoremodal:   true
              , learnmorebtn:     'Read About Our Integration'
              , learnmorelink:    '/blog/now-integrated-with-zoom.cfm'
              , managebtn:        false
              , managebtnlabel:   ''
              , managebtnshowicon: false
              , order:            3
              , controlled:       false
              , enabled:          true
          }
        ];

        sug_integrations.statusmsg = {
            type:         'success'
          , title:        ''
          , text:         ''
          , dismissable:  true
          , show:         false
          , noshadow:     true
          , reset:        true
        };

        /* These will be set by view controllers */
        $scope.strings = {
              errors: {
                errorsTitle: ''
              , errorsPleaseCorrect: 'Please correct the following issues:'
            },
            probadge:   'Paid feature'
        };

        //init error service
        $scope.es = errorService;
        $scope.es.init();


        /************************
         EVENT LISTENERS
        ************************/

        /**
         * Handler for processing Status
         */
        $scope.$on('isProcessing', function (event, processing) {
            $scope.isProcessing = processing;
            if ($scope.isProcessing) {
                SUGUtilities.showLoading('processing');
            }
        });

        /**
         * Scroll to top on successful route
         */
        $scope.$on('$routeChangeSuccess', function () {
            $window.scrollTo(0, 0);
        });

        /**
         * Event handler for NPE Login
         * Use generic JS event because NPE Login window is in its own SUGAPP scope
         * Generic event is also compatible with IE and other browsers
         */
		var eventMethod = $window.addEventListener ? "addEventListener" : "attachEvent";
		var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
        var npeLoginEventListener = $window[eventMethod];
        var windowOrigin = window.globalcfg.secureURL;

		// Listen for the postMessage from NPE Login indicating the login process is complete
		npeLoginEventListener(messageEvent,function(e) {
            // Verify the origin of the message and the payload
            if( e.origin === windowOrigin
                && e.source !== 'undefined'
                && e.source.name.toString().includes("integration_npelogin")
                && typeof e.data !== 'undefined'
                && typeof e.data === "object"
                && typeof e.data.status !== 'undefined'
                && typeof e.data.key !== 'undefined'
            ){
                try {
                    if(e.data.status != 'login required'){
                        //close the window
                        _loginwindow.close();

                        //route the page
                        $timeout(function(){
                            $location.path( "/integration/" + e.data.key.toString().toLowerCase().trim() + "/" + $scope.userdef.memberid );
                        },10);
                    } else {
                        $scope.es.setError('manage_integrations', e.data.message );
                    }
                } catch(err){
                    // error for production
                    $scope.es.setError('manage_integrations', 'Unexpected error occurred.' );

                    // for debugging dump the error on non-production servers
                    if( $scope.fullsecureurl != 'https://www.signupgenius.com' ){
                        console.log('LOGIN WINDOW ERROR\n',err);
                        //console.log('EVENT\n',e);
                        //console.log('EXPECTED ORIGIN\n',windowOrigin);
                    }
                }
            }
        } );



        /**
         * *** START THE WORKFLOW ***
         */
        var init = function() {
            SUGUtilities.broadCast('isProcessing', true);
            loadData();
        };


        /************************
         MANAGE DATA
        ************************/

        /* Get Data */
        var loadData = function() {

            loadUserData()
            .then(function(userdef){
                $scope.userdef = SUGUtilities.lowerCaseKeys( userdef );

                isAppFeatureEnabled()
                .then(function(appFeatureEnabled){

                    if( appFeatureEnabled ){

                        //Update the NPE Integration
                        var npeobj = $filter('filter')($scope.integrations, {classname: 'npe'});
                        if( npeobj.length ){
                            npeobj[0].enabled = appFeatureEnabled;
                        }

                        //determine if the Member has the feature or feature exception
                        hasNpeFeature()
                        .then(function(memberFeaturecheck){
                            //Update user data for the NPE feature (simulates hasFeatures)
                            $scope.userdef.features.nonprofiteasy = memberFeaturecheck;

                            if(memberFeaturecheck){
                                //If feature is enabled, check to see if the user already has an api tokens
                                authorizeNPE('npe')
                                .then(function(){
                                    $scope.loaded=true;
                                });

                            } else {
                                $scope.loaded=true;
                                SUGUtilities.broadCast('isProcessing', false);
                            }

                        }); // END hasNpeFeature

                    } else {
                        // IF appFeatureEnabled is false
                        $scope.loaded=true;
                        SUGUtilities.broadCast('isProcessing', false);
                    }

                });  // END isAppFeatureEnabled

            }); // END loadUserData
        };

        var loadUserData = function(){
            var deferred = $q.defer();
            var userdef = sugCacheFactory.get('integration_userdef', {});

            if( !Object.keys(userdef).length ){
                if( typeof window.userdef !== 'undefined'){
                    userdef.memberid = window.userdef.memberid;
                    userdef.ownerid = window.userdef.ownerid;
                    userdef.email = window.userdef.email;
                    userdef.istrial = window.userdef.istrial;
                    userdef.usertype = window.userdef.usertype;
                    userdef.parentid = window.userdef.parentid;
                    userdef.features = {};

                    sugCacheFactory.set('integration_userdef',userdef);

                    deferred.resolve(userdef);
                } else {
                    //if userdef isn't available, we'll need to do a data call for memberinfo
                    globalService.getMemberInformation()
                    .then(function (response) {
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // invalid response, show error
                            $scope.es.setError('manage_integrations', SUGUtilities.getAjaxResponseMessage(response) );
                            deferred.reject();
                        } else {
                            // successfully retrieved memberInfo, update $scope
                            var r = SUGUtilities.lowerCaseKeys(response);

                            userdef.memberid = r.data.data.memberId;
                            userdef.ownerid = r.data.data.parentid;
                            userdef.email = r.data.data.email;
                            userdef.istrial = r.data.data.istrialuser;
                            userdef.usertype = r.data.data.productlabel;
                            userdef.parentid = r.data.data.memberId != r.data.data.parentid ? 1 : 0;
                            userdef.features = {};

                            sugCacheFactory.set('integration_userdef',userdef);
                            deferred.resolve(userdef);
                        }
                    });
                }
            }
            return deferred.promise;
        };

        /**
         * Method checks to see if the application feature is enabled
         */
        var isAppFeatureEnabled = function(){
            var deferred = $q.defer();

            integrationService.isAppFeatureEnabled({featurename:_appFeatureName})
            .then(function(response){
                if(SUGUtilities.ajaxResultInvalid(response)) {
                    // invalid response, show error
                    $scope.es.setError('manage_integrations', SUGUtilities.getAjaxResponseMessage(response) );
                    $scope.loaded=true;
                    deferred.reject();
                }else{
                    var r = SUGUtilities.lowerCaseKeys(response);
                    if( r.data.success ){
                        deferred.resolve(r.data.data.enabled);
                    } else {
                        if( r.data.message.length ){
                            $scope.es.setError('manage_integrations', r.data.message[0] );
                        } else {
                            $scope.es.setError('manage_integrations', 'An error occurred checking the application feature' );
                        }
                        $scope.loaded=true;
                        deferred.reject();
                    }
                }
            });
            return deferred.promise;
        };

        /**
         * Method checks to see if the member has the feature or feature exception
         */
        var hasNpeFeature = function(){
            var deferred = $q.defer();

            integrationService.memberHasNPEFeature({ skipAppFeatureCheck:true }) //app feature check was run above
            .then(function(response){
                if(SUGUtilities.ajaxResultInvalid(response)) {
                    // invalid response, show error
                    $scope.es.setError('manage_integrations', SUGUtilities.getAjaxResponseMessage(response) );
                    $scope.loaded=true;
                    deferred.reject();
                }else{
                    var r = SUGUtilities.lowerCaseKeys(response);
                    if( r.data.success ){
                        //save result in local factory
                        sugCacheFactory.set('integration_hasNPEFeature', r.data.data.hasfeature);

                        deferred.resolve(r.data.data.hasfeature);
                    } else {
                        if( r.data.message.length ){
                            $scope.es.setError('manage_integrations', r.data.message[0] );
                        } else {
                            $scope.es.setError('manage_integrations', 'An error occurred checking the member feature' );
                        }
                        $scope.loaded=true;
                        deferred.reject();
                    }
                }
            });
            return deferred.promise;
        };

        /**
         * Helper method to return one of the Integration object models from the data array
         * @param {string} key - REQUIRED; the integration's classname value
         */
        var getIntegration = function( key ){
            var integration = $filter('filter')($scope.integrations, {'classname':key});
            return integration.length ? integration[0] : {};
        };

        /**
         * Helper method to determine if the user has valid OAuth Tokens for NPE
         * This is used to determine access to the manage NPE page
         * @param {string} key - REQUIRED; the integration's classname value
         */
        var authorizeNPE = function( key ){
            SUGUtilities.broadCast('isProcessing', true);

            var deferred = $q.defer();

            integrationService.authorizeNPE()
            .then(function (response) {
                if (SUGUtilities.ajaxResultInvalid(response)) {
                    // invalid response, show error
                    $scope.es.setError('manage_integrations', SUGUtilities.getAjaxResponseMessage(response) );
                    SUGUtilities.broadCast('isProcessing', false);
                    deferred.reject();
                } else {
                    // successful - set some vars later use
                    var r = SUGUtilities.lowerCaseKeys(response);
                    var payload = r.data.data;

                    sugCacheFactory.set('integration_npetokens',payload);

                    _hasNpeTokens = payload.status != 'login required' ? true : false;
                    _npeLoginUrl = payload.loginurl;

                    if(_hasNpeTokens){
                        //Update the NPE Manage button label
                        var npeobj = $filter('filter')($scope.integrations, {classname: key});
                         if( npeobj.length ){
                            npeobj[0].managebtnshowicon = true;
                            npeobj[0].managebtnlabel = 'Manage Integration';
                         }
                    }

                    SUGUtilities.broadCast('isProcessing', false);
                    deferred.resolve();
                }
            });

            return deferred.promise;
        };

        /**
         * Method opens a new window to login and/or setup the NPE API
         * If the user already has API oath tokens stored this isn't necessary
         * @param {string} loginurl - REQUIRED; url for the NPE API login
         */
        var openNpeWindow = function( loginurl ){
            if( typeof loginurl != 'undefined' && loginurl.toString().length ){
                var winProps = 'width=490,height=785,left=' + ( (window.outerWidth - 490)/2 ) + ',top=100';
                var winName = 'integration_npelogin';
                _loginwindow = $window.open(loginurl, winName, winProps);
            }
        };



        /************************
         EXPOSED FUNCTIONS
        ************************/

        /**
         * Method to toggle Pro Badge
         * If Pro feature and a higher product level than the current user's product level
         * @param {object} integration - REQUIRED; A valid integration data object
         */
        $scope.showprobadge = function( integration ){
            var featurename = integration.name.toString().toLowerCase().trim();
            return integration.ispro && (
                    //If the integration is enabled but not defined for the user (we are displaying the Learn More version of the block)
                    (integration.enabled && typeof $scope.userdef.features[featurename] == 'undefined')
                    ||
                    //Or the feature IS defined and the user explicitly doesn't have it
                    (typeof $scope.userdef.features[featurename] != 'undefined' && !$scope.userdef.features[featurename]))
                ? true : false;
        };

        /**
         * Method to toggle Learn More link
         * @param {object} integration - REQUIRED; A valid integration data object
         */
        $scope.showlearnmore = function( integration ){
            return integration.learnmoremodal ? true : false;
        };

        /**
         * Method to toggle Manage button
         * Manage Button is defined and the integration product level is at or below the current user's product level
         * @param {object} integration - REQUIRED; A valid integration data object
         */
        $scope.showmanage = function( integration ){
            var featurename = integration.name.toString().toLowerCase().trim();
            return ( integration.managebtn && (typeof $scope.userdef.features[featurename] != 'undefined' && $scope.userdef.features[featurename]) ) ? true : false;
        };

        /**
         * Method verifies API access and either opens the NPE management page
         * or spawns the NPE API login window
         * @param {string} key - REQUIRED; NPE integration reference key
         */
        $scope.manage = function( key ){
            /* If _hasNpeTokens is null (object in JS) and we don't have any errors,
               run authorizeNPE(). This shouldn't happen bc runs on page load. */
            if(!_hasNpeTokens && !$scope.es.getErrors('manage_integrations')){
                authorizeNPE( key )
                .then(function(){
                    if( _hasNpeTokens ){
                        $location.path( "/integration/" + key + '/' + $scope.userdef.memberid );
                    } else {
                        openNpeWindow( _npeLoginUrl );
                    }
                });
            } else {
                //This block will almost always run when manage() is called
                if( _hasNpeTokens ){
                    $location.path( "/integration/" + key + '/' + $scope.userdef.memberid );
                } else {
                    openNpeWindow( _npeLoginUrl );
                }
            }
        };

        /**
         * Method loads data for the specified integration and
         * opens a learn more modal with additional details.
         * @param {string} key - REQUIRED; NPE integration reference key
         */
        $scope.learnmore = function( key ){
            var integration = getIntegration(key);

            if( Object.keys(integration).length ){
                var learnMoreBtn = '';

                if(typeof integration.learnmorelink !== 'undefined' && integration.learnmorelink.toString().length ){
                    learnMoreBtn =  '<div align="center" style="margin-top:20px">' +
                                    '<a href=' + integration.learnmorelink + ' class="btn btn-lg btn-orange" target="_blank">' + integration.learnmorebtn + '</a>' +
                                    '</div>';
                }

                $.magnificPopup.open({
                    mainClass: 'mfp-fade',
                    removalDelay: 300,
                    items: {
                        src: 	'<div id="feature" class="white-popup modal-tiny">' +
                                    '<div class="feat-pic" align="center">' +
                                    '<img class="img-responsive zoom-in" src="' + integration.modalimage + '"></div>' +
                                    '<p class="feat-desc">' + integration.fulldesc + '</p>' + learnMoreBtn +
                                '</div>'
                    },
                    type: 'inline'
                });

            }
        };

        /**
        * Updates the text of the Manage button for the specified integration
        * Added to the shared scope so other controllers can easily access the manage button label
        *
        * @param String key - Integration key for the integration to update
        * @param String label - New text label for the manage button
        */
        sug_integrations.updateManageBtn = function( key, label, showicon ){
            if( key.toString().length && label.toString().length ){
                showicon = typeof showicon == 'undefined' ? true : showicon;
                var integration = $filter('filter')($scope.integrations, {classname: key});
                if( integration.length ){
                    integration[0].managebtnlabel = label.toString();
                    integration[0].managebtnshowicon = showicon;
                }
            }
        };

        /**
        * Resets the has tokens var after NPE is disabled
        */
        sug_integrations.resetNpeTokens = function(){
            _hasNpeTokens = null;
        };

        init();
    }
}());